import Status from "./Status";
import UpcomingUserAppointment from "./UpcomingUserAppointment";

export default class UpcomingUserAppointmentsList {
  constructor(
    public readonly appointments: UpcomingUserAppointment[],
    public readonly status: Status,
  ) {}
}
